const publish = () => import('../views/system/publisher')
const basicInformation = () =>
  import('../views/system/publisher/basic-information')
const banners = () => import('../views/system/publisher/banners')
const publisherPolicy = () =>
  import('../views/system/publisher/publisher-policy')
const keyRelationship = () =>
  import('../views/system/publisher/key-relationship')
const database = () => import('../views/system/publisher/database')
const managementTeam = () => import('../views/system/publisher/management-team')
const info = () => import('../views/system/publisher/info')
const manageAuthority = () => import('../views/system/manage-authority')
const manageAuthorityDetail = () =>
  import('../views/system/manage-authority/detail')

const manageQuestionnaire = () => import('../views/system/manage-questionnaire')
const manageQuestionnaireAdd = () =>
  import('../views/system/manage-questionnaire/add')
const path = '/system'

const manageEmail = () => import('../views/system/manage-email')
const emailTemplate = () =>
  import('../views/system/manage-email/email-template')
const emailTemplateAdd = () =>
  import('../views/system/manage-email/email-template/add')
const actions = () => import('../views/system/manage-email/actions')
const associated = () =>
  import('../views/system/manage-email/actions/associated-mail')
const emailSignature = () =>
  import('../views/system/manage-email/email-signature')
const checklist = () => import('../views/system/manage-email/checklist')
const emailAddress = () => import('../views/system/manage-email/email-address')
const emailRecords = () =>
  import('../views/system/manage-email/communication-records')

const operationRecord = () => import('../views/system/operation-record')

const journalSetting = () => import('../views/system/journal-setting')
const generalSetting = () =>
  import('../views/system/journal-setting/general-setting')
const countrySetting = () =>
  import('../views/system/journal-setting/country-setting')
const articleTypeSetting = () =>
  import('../views/system/journal-setting/article-type-setting')

const publisherSetting = () => import('../views/system/publisher-setting')
const publisherGeneral = () =>
  import('../views/system/publisher-setting/general-setting')
const publisherEmail = () =>
  import('../views/system/publisher-setting/email-setting')
const publisherArticalType = () =>
  import('../views/system/publisher-setting/article-type-setting')
const publisherCountry = () =>
  import('../views/system/publisher-setting/country-setting')

const contentSetting = () => import('../views/system/content-setting')

export default [
  {
    path: path + '/publisher',
    component: publish,
    name: '/system/publisher',
    children: [
      {
        path: path + '/publisher/basic-information',
        component: basicInformation,
        name: '/system/publisher/basic-information'
      },
      {
        path: path + '/publisher/banners',
        component: banners,
        name: '/system/publisher/banners'
      },
      {
        path: path + '/publisher/publisher-policy',
        component: publisherPolicy,
        name: '/system/publisher/publisher-policy'
      },
      {
        path: path + '/publisher/key-relationship',
        component: keyRelationship,
        name: '/system/publisher/key-relationship'
      },
      {
        path: path + '/publisher/database',
        component: database,
        name: '/system/publisher/database'
      },
      {
        path: path + '/publisher/management-team',
        component: managementTeam,
        name: '/system/publisher/management-team'
      },
      {
        path: path + '/publisher/info',
        component: info,
        name: '/system/publisher/info'
      }
    ]
  },
  {
    path: path + '/manage-authority',
    component: manageAuthority,
    name: '/system/manage-authority',
    children: [
      {
        path: path + '/manage-authority/:id',
        component: manageAuthorityDetail,
        name: '/system/manage-authority/:id'
      }
    ]
  },
  {
    path: path + '/manage-questionnaire',
    component: manageQuestionnaire,
    name: '/system/manage-questionnaire'
  },
  {
    path: path + '/manage-questionnaire/add',
    component: manageQuestionnaireAdd,
    name: '/system/manage-questionnaire/add'
  },
  {
    path: path + '/manage-questionnaire/edit/:id',
    component: manageQuestionnaireAdd,
    name: '/system/manage-questionnaire/edit/:id'
  },
  {
    path: path + '/manage-email',
    component: manageEmail,
    name: '/system/manage-email',
    children: [
      {
        path: path + '/manage-email/email-template',
        component: emailTemplate,
        name: '/system/manage-email/email-template'
      },
      {
        path: path + '/manage-email/actions',
        component: actions,
        name: '/system/manage-email/actions'
      },
      {
        path: path + '/manage-email/email-signature',
        component: emailSignature,
        name: '/system/manage-email/email-signature'
      },
      {
        path: path + '/manage-email/email-address',
        component: emailAddress,
        name: '/system/manage-email/email-address'
      },
      {
        path: path + '/manage-email/checklist',
        component: checklist,
        name: '/system/manage-email/checklist'
      },
      {
        path: path + '/manage-email/records',
        component: emailRecords,
        name: '/system/manage-email/records'
      }
    ]
  },
  {
    path: path + '/manage-email/actions/associated',
    component: associated,
    name: '/system/manage-email/actions/associated'
  },
  {
    path: path + '/manage-email/email-template/add',
    component: emailTemplateAdd,
    name: '/system/manage-email/email-template/add'
  },
  {
    path: path + '/manage-email/email-template/:id',
    component: emailTemplateAdd,
    name: '/system/manage-email/email-template/:id'
  },
  {
    path: path + '/operation-record',
    component: operationRecord,
    name: '/system/operationRecord'
  },
  {
    path: path + '/content-setting',
    component: contentSetting,
    name: '/system/content-setting'
  },
  {
    path: path + '/journal-setting',
    component: journalSetting,
    name: '/system/journal-setting',
    children: [
      {
        path: path + '/journal-setting/general-setting',
        component: generalSetting,
        name: '/system/journal-setting/general-setting'
      },
      {
        path: path + '/journal-setting/country-setting',
        component: countrySetting,
        name: '/system/journal-setting/country-setting'
      },
      {
        path: path + '/journal-setting/article-type-setting',
        component: articleTypeSetting,
        name: '/system/journal-setting/article-type-setting'
      }
    ]
  },
  {
    path: path + '/dictpublisher-setting',
    component: publisherSetting,
    name: '/system/dictpublisher-setting',
    children: [
      {
        path: path + '/dictpublisher-setting/email-setting',
        component: publisherEmail,
        name: '/system/dictpublisher-setting/email-setting'
      },
      {
        path: path + '/dictpublisher-setting/general-setting',
        component: publisherGeneral,
        name: '/system/dictpublisher-setting/general-setting'
      },
      {
        path: path + '/dictpublisher-setting/country-setting',
        component: publisherCountry,
        name: '/system/dictpublisher-setting/country-setting'
      },
      {
        path: path + '/dictpublisher-setting/article-type-setting',
        component: publisherArticalType,
        name: '/system/dictpublisher-setting/article-type-setting'
      }
    ]
  }
]
